const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    clientUrl: "https://client.trackmydoc.com",
  },
  "backoffice-tazimmigration.trackmydoc.com": {
    name: "Taz Immigration",
    domainName: "tazimmigration.com",
    logo: "/assets/logo/logo.png",
    favicon: "/assets/logo/favicon.ico",
    clientUrl: "https://client-tazimmigration.trackmydoc.com",
  }
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
